import React from 'react';
import { Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-[#E5E2DA] bg-[#FAF9F6] py-12">
      <div className="wrap">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pb-8 border-b border-[#E5E2DA]/80">
          <div>
            <a 
              href="#top" 
              className="flex items-center hover:opacity-90 transition-opacity"
            >
              <img 
                src="/logo.svg" 
                alt="Sparklyt" 
                className="h-7 md:h-8 w-auto object-contain" 
              />
            </a>
            <p className="text-[14.5px] text-[#635F58] mt-2">
              Find out what your child is actually drawn to. Class 8 to 12, Bengaluru.
            </p>
          </div>

          <div className="flex items-center gap-4 text-[14.5px] text-[#635F58]">
            <a 
              href="tel:8904145446" 
              className="inline-flex items-center gap-2 font-medium text-[#1A1917] hover:text-[#C07A22] transition-colors"
            >
              <Phone size={14} className="text-[#C07A22]" />
              8904145446 (Pranav, Founder)
            </a>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-[13.5px] text-[#8E8A82]">
          <p>© {new Date().getFullYear()} Sparklyt. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="https://app.sparklyt.com" className="hover:text-[#1A1917] transition-colors">
              App Portal
            </a>
            <a href="https://www.linkedin.com/in/m-pranav-7a0017275/" target="_blank" rel="noopener noreferrer" className="hover:text-[#1A1917] transition-colors">
              Founder LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
